export default __webpack_public_path__ + "static/media/DiscountGroup.9d81f80b.xlsx";